<template>
  <v-app class="app-tabela">
    <!-- <div class="info-table py-4">
      <div class="info-table-item">
        <vue-select
          :options="periodos"
          label="label"
          placeholder="Período"
          v-model="periodo"
          @input="handlePeriod($event)"
          :clearable="true"
        >
          <template slot="option" slot-scope="option">
            {{ option.label }}
          </template>
          <div slot="no-options">Não há opções correspondentes</div>
        </vue-select>
      </div>
    </div> -->
    <v-card class="tabela">
      <v-card-title>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          class="input-bottom"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        @pagination="getPagination"
        :page="currentPage"
        :footer-props="{
          itemsPerPageText: '',
          'items-per-page-options': [10],
          'disable-items-per-page': true,
        }"
        :loading="loading"
        loading-text="Carregando, Por favor espere"
        :headers="headers"
        :items="indexedItems"
        :search="search"
        item-key="index"
        class="elevation-1"
        :single-expand="true"
        :expanded.sync="expanded"
        show-expand
      >
        <template v-slot:header.situacao="{ header }">
          {{ header.text }}
          <span
            v-b-tooltip.hover.right
            :title="header.tooltip"
            class="icon-tooltip"
          >
            <i class="icofont-info-circle"></i>
          </span>
        </template>

        <template v-slot:item.no_equipe="{ item }">
          <td>
            {{ item.nu_ine }}
            <span
              v-if="item.no_equipe"
              v-b-tooltip.hover
              v-bind:title="item.no_equipe"
              class="icon-tooltip"
            >
              <i class="icofont-info-circle"></i>
            </span>
          </td>
        </template>

        <template v-slot:item.co_cbo="{ item }">
          <td>
            {{ item.nu_cbo }}
            <span
              v-if="item.no_cbo"
              v-b-tooltip.hover
              v-bind:title="item.no_cbo"
              class="icon-tooltip"
            >
              <i class="icofont-info-circle"></i>
            </span>
          </td>
        </template>

        <template v-slot:item.dt_atendimento="{ item }">
          <td>
            {{
              item.dt_atendimento != null ? formatDate(item.dt_atendimento) : ''
            }}
          </td>
        </template>

        <template v-slot:item.tipo="{ item }">
          <td>
            {{ item.tipo != null ? JSON.parse(item.tipo).join(', ') : '' }}
          </td>
        </template>

        <template v-slot:expanded-item="{ headers, item }">
          <td colspan="9">
            <b-alert
              v-if="item.dt_nascimento != cidadao.dt_nascimento"
              variant="danger"
              show
              class="mt-4"
            >
              A data de nascimento registrada nesse atendimento
              {{
                item.dt_nascimento != null ? formatDate(item.dt_nascimento) : ''
              }}
              é diferente da data de nascimento atual do cidadão
              {{
                cidadao.dt_nascimento != null
                  ? formatDate(cidadao.dt_nascimento)
                  : ''
              }}.
            </b-alert>

            <b-alert
              v-if="
                filtroAtendimento.filtro == 'gestante' && item.nu_ms != '71'
              "
              variant="danger"
              show
              class="mt-4"
            >
              O profissional que realizou atendimento na gestante não está
              vinculado a uma equipe de Saúde Bucal (eSB).
            </b-alert>
          </td>
        </template>

        <template v-slot:[`footer.page-text`]="items">
          <div class="info-table-item tabela-esus-pec">
            <FonteSincronizadorC />
          </div>
          <span class="paginacao"
            >{{ items.pageStart }} - {{ items.pageStop }} de
            {{ items.itemsLength }} registros</span
          >
        </template>

        <template v-slot:no-data>
          <div class="alert alert-info mb-0">
            <b>Nenhuma informação encontrada.</b>
          </div>
        </template>
        <template v-slot:no-results style="padding: 0px">
          <div class="alert alert-info mb-0">
            <b>Nenhuma informação encontrada.</b>
          </div>
        </template>
      </v-data-table>
    </v-card>
  </v-app>
</template>

<script>
import utils from '@/mixins/utils.js'

export default {
  name: 'Odonto',
  props: {
    cidadao: {
      type: Object,
      default: () => null,
    },
    filtroAtendimento: {
      type: Object,
      default: () => ({ filtro: null, operador: '>=', data: '' }),
    },
  },
  mixins: [utils],
  data() {
    return {
      expanded: [],
      headers: [
        {
          text: 'ATENDIMENTO',
          align: 'start',
          filterable: false,
          sortable: true,
          value: 'dt_atendimento',
        },
        {
          text: 'CPF',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'cpf',
        },
        {
          text: 'CNS',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'cns',
        },
        {
          text: 'EQUIPE',
          align: 'start',
          filterable: false,
          sortable: true,
          value: 'no_equipe',
        },
        {
          text: 'CBO',
          align: 'start',
          filterable: false,
          sortable: true,
          value: 'co_cbo',
        },
        {
          text: 'TIPO',
          align: 'start',
          filterable: false,
          sortable: false,
          value: 'tipo',
        },
        { text: '', value: 'data-table-expand' },
      ],
      cadastrosOriginais: [],
      cadastros: [],
      currentPage: 1,
      search: '',
      loading: false,
      cnsList: [],
      periodos: [{ label: 'Últimos 13 meses', value: 13 }],
      periodo: null,
    }
  },
  mounted() {
    this.buscarDados()
  },
  computed: {
    cadastrosFiltrados() {
      const { operador, data } = this.filtroAtendimento || {}

      // sem data ou sem operador: retorna tudo
      if (!data || !operador) return this.cadastros

      return this.cadastros.filter((item) => {
        const dataItem = item.dt_atendimento.split('/').reverse().join('-')
        return this._compareDates(dataItem, data, operador)
      })
    },

    indexedItems() {
      return this.cadastrosFiltrados.map((item, index) => ({
        index,
        ...item,
      }))
    },
  },
  methods: {
    getPagination(options) {
      this.currentPage = options.page
    },

    _compareDates(aYmd, bYmd, op) {
      if (!aYmd || !bYmd) return true
      switch (op) {
        case '>':
          return aYmd > bYmd
        case '<':
          return aYmd < bYmd
        case '>=':
          return aYmd >= bYmd
        case '<=':
          return aYmd <= bYmd
        case '=':
          return aYmd === bYmd
        default:
          return true
      }
    },

    diffMonthsFromDate(date) {
      const [year, month, day] = date.split('-')
      const startDate = new Date(year, month - 1, day)
      let today = new Date()
      let months = (today.getFullYear() - startDate.getFullYear()) * 12
      months -= startDate.getMonth()
      months += today.getMonth()
      return months
    },

    handlePeriod(periodo) {
      if (periodo == null) {
        this.cadastros = this.cadastrosOriginais
        return
      }
      this.cadastros = this.cadastrosOriginais.filter((item) => {
        let itemDate = item.dt_atendimento
        let monthsDiff = this.diffMonthsFromDate(itemDate)
        return monthsDiff <= periodo.value
      })
    },

    async buscarDados() {
      try {
        this.loading = true

        // Pega a lista de cns
        const response = await this.$api.get(
          `/app/cidadao/${this.$store.state.cod_ibge}/${this.cidadao.nu_cpf}/${this.cidadao.nu_cns}/cadastros`
        )
        if (response) {
          this.cnsList = [
            ...new Set(
              response.data
                .map((i) => (i?.cns != null ? String(i.cns).trim() : null))
                .filter((cns) => cns !== null && cns !== '')
            ),
          ]
        }

        if (this.cnsList.length == 0) {
          this.cnsList = [0]
        }

        const response2 = await this.$api.post(`/app/cidadao/odonto`, {
          co_ibge: this.$store.state.cod_ibge,
          cpf: this.cidadao.nu_cpf,
          cns: this.cnsList,
        })
        if (response2) {
          this.cadastrosOriginais = response2.data
          this.cadastros = response2.data
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style></style>
